import {
  Alert,
  Checkbox,
  Col,
  Descriptions,
  Form,
  Input,
  Modal,
  Row,
  Typography,
} from 'antd';
import { useEffect, useState } from 'react';
import INTERNAL_LINKS from '../../enums/InternalLinks';
import PdfViewer from '../../components/PdfViewer';
import {
  certificatesTable,
  getContractDetails,
  post as createCertificate,
  get as getUrl,
} from '../../api/module/ct_certifications';
import { AjaxTable, CustomButton } from '../../components';
import { catchExceptionSRate } from '../../utils/helpers/helpers';
import BreadcrumbContainer from '../../containers/Breadcrumb';
import { Link } from 'react-router-dom';

const { Title, Text } = Typography;
const breadcrumbItems = [
  {
    text: 'Certificaciones',
    to: INTERNAL_LINKS.CT_CERTIFICATIONS,
  },
  {
    text: 'Certificaciones Específicas',
  },
];

const AddModal = ({ contract_id, onFinish, onCancel }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  async function onSelfFinish(data) {
    try {
      setLoading(true);
      await onFinish({ ...data, contrato: contract_id });
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }

  if (!contract_id) return null;
  return (
    <Modal
      open={true}
      footer={
        <CustomButton
          onClick={() => form.submit()}
          text="Generar certificación"
          loading={loading}
        />
      }
      styles={{ footer: { display: 'flex', justifyContent: 'center' } }}
      title="Generación de Certificación"
      onCancel={onCancel}
      width={'80%'}
    >
      <Form
        form={form}
        onFinish={onSelfFinish}
        layout="vertical"
        initialValues={{
          info_estado: true,
          info_objeto: true,
          info_duracion: true,
          info_obligaciones: false,
          info_productos: false,
          info_valor: false,
          info_forma_pago: false,
          info_lugar: false,
          info_dirigido: false,
        }}
        preserve={false}
      >
        <Text>
          Seleccione la información que requiere en su certificación a generar
        </Text>
        <br />
        <br />
        <Row gutter={12} style={{ margin: '0 3em 0 3em' }}>
          <Col span={8}>
            <Form.Item
              name="info_estado"
              labelCol={{ span: 0 }}
              valuePropName="checked"
            >
              <Checkbox disabled>Estado del contrato</Checkbox>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="info_objeto"
              labelCol={{ span: 0 }}
              valuePropName="checked"
            >
              <Checkbox disabled>Objeto</Checkbox>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="info_duracion"
              labelCol={{ span: 0 }}
              valuePropName="checked"
            >
              <Checkbox disabled>Duración</Checkbox>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="info_obligaciones"
              labelCol={{ span: 0 }}
              valuePropName="checked"
            >
              <Checkbox>Obligaciones</Checkbox>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="info_productos"
              labelCol={{ span: 0 }}
              valuePropName="checked"
            >
              <Checkbox>Productos</Checkbox>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="info_valor"
              labelCol={{ span: 0 }}
              valuePropName="checked"
            >
              <Checkbox>Valor total</Checkbox>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="info_forma_pago"
              labelCol={{ span: 0 }}
              valuePropName="checked"
            >
              <Checkbox>Forma de pago</Checkbox>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="info_lugar"
              labelCol={{ span: 0 }}
              valuePropName="checked"
            >
              <Checkbox>Lugar de ejecución</Checkbox>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="info_dirigido"
              labelCol={{ span: 0 }}
              valuePropName="checked"
            >
              <Checkbox>Dirigido a</Checkbox>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item noStyle dependencies={['info_dirigido']}>
              {({ getFieldValue }) =>
                getFieldValue('info_dirigido') ? (
                  <Form.Item
                    name="info_dirigido_a"
                    label="Digite a quien va dirigida la certificación"
                    rules={[
                      { required: true, message: 'Este campo es obligatorio' },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                ) : null
              }
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

const CTSpecificCertifications = ({ match, createPerm }) => {
  const [contractData, setContractData] = useState();
  const [reloadSource, setReloadSource] = useState(false);
  const [loadingUrl, setLoadingUrl] = useState(false);
  const [pdfUrl, setPDFUrl] = useState();
  const [formOpen, setFormOpen] = useState();

  useEffect(() => {
    async function fetchData() {
      try {
        const { data: resData } = await getContractDetails(
          match.params.contrato_id,
        );
        setContractData(resData);
      } catch (error) {
        catchExceptionSRate(error);
      }
    }
    fetchData();
  }, []);

  const onOpenForm = () => {
    setFormOpen(contractData.pk);
  };

  const onFinish = async (data) => {
    try {
      await createCertificate(data);
      setReloadSource({});
      setFormOpen();
    } catch (error) {
      catchExceptionSRate(error);
    }
  };

  async function getPdfURL(id) {
    try {
      setLoadingUrl(true);
      const { data: dataUrl } = await getUrl(id);
      setPDFUrl(dataUrl.url);
    } catch (error) {
      catchExceptionSRate(error);
    } finally {
      setLoadingUrl(false);
    }
  }

  const columns = [
    {
      title: 'Fecha de generación',
      dataIndex: 'fecha',
    },
    {
      title: 'Estado de contrato al generar certificación',
      dataIndex: 'estado_nombre',
    },
    {
      key: 'acciones',
      title: 'Acciones',
      width: '10em',
      render: (_, record) =>
        record.estado_firma === 4 ? (
          <CustomButton
            text="Visualizar"
            type="default"
            htmlType="button"
            block
            onClick={() => getPdfURL(record.id)}
            loading={loadingUrl}
          />
        ) : (
          'Generación en proceso'
        ),
    },
  ];

  return (
    <>
      <BreadcrumbContainer items={breadcrumbItems} />
      <Title className={'text-uppercase'} level={2}>
        CERTIFICACIONES ESPECÍFICAS
      </Title>
      <Descriptions
        layout="horizontal"
        column={2}
        bordered
        styles={{
          label: { maxWidth: '15em' },
        }}
      >
        <Descriptions.Item label="Nombre completo / Razón social" span={2}>
          {contractData?.contratista_nombre}
        </Descriptions.Item>
        <Descriptions.Item label="Tipo de documento">
          {contractData?.tipo_identificacion_nombre}
        </Descriptions.Item>
        <Descriptions.Item label="Número de documento">
          {contractData?.identificacion}
        </Descriptions.Item>
        <Descriptions.Item label="Proyecto" span={2}>
          {contractData?.proyecto}
        </Descriptions.Item>
        <Descriptions.Item label="Nro. Contrato">
          {contractData?.contrato_num}
        </Descriptions.Item>
        <Descriptions.Item
          label="Cargo"
          styles={{ content: { maxWidth: '20em' } }}
        >
          {contractData?.rol}
        </Descriptions.Item>
      </Descriptions>
      <br />
      {createPerm && (
        <CustomButton
          htmlType="button"
          text="Generar nuevo certificado"
          onClick={onOpenForm}
          disabled={!contractData}
        />
      )}
      {contractData && (
        <AjaxTable
          tableTitle="Listado de Certificaciones ya generadas"
          columns={columns}
          query={`filter[contrato]=${contractData.pk}`}
          endpoint={certificatesTable}
          reloadSource={reloadSource}
          searchInput
          exportCSV
          reloadButton
        />
      )}
      <AddModal
        contract_id={formOpen}
        onCancel={() => setFormOpen()}
        onFinish={onFinish}
      />

      <PdfViewer
        pdf={pdfUrl}
        onCancel={() => setPDFUrl(undefined)}
        open={pdfUrl}
      />
      <br />
      <Link to={`${INTERNAL_LINKS.CT_CERTIFICATIONS}`}>
        <CustomButton
          type={'default'}
          className={'back-button'}
          htmlType="button"
          text={'Volver'}
        />
      </Link>
    </>
  );
};

export default CTSpecificCertifications;
